import React from 'react';
import moment from 'moment';
import Table from '../../commonComponents/Table';
import TablePagination from '../../commonComponents/Pagination';
import type { ColumnsType } from 'antd/es/table';
import { TableWrapper, LogLink } from './Styles';
import { Log, LogsTableProps } from './types';

const LogsTable: React.FC<LogsTableProps> = ({
  logs,
  loading,
  isAdmin,
  isDarkMode,
  totalItems,
  currentPage,
  pageSize,
  onLogClick,
  onPaginationChange,
}) => {
  const columns: ColumnsType<Log> = [
    {
      title: 'Log ID',
      dataIndex: 'id',
      key: 'id',
      width: 120,
    },
    {
      title: 'Device Name',
      dataIndex: 'logDeviceName',
      key: 'logDeviceName',
      width: 150,
    },
    ...(isAdmin
      ? [
          {
            title: 'Merchant',
            dataIndex: 'merchant',
            key: 'merchant',
            width: 150,
            render: (merchant: string) => merchant || 'N/A',
          },
        ]
      : []),
    {
      title: 'Log',
      dataIndex: 'logDeviceName',
      key: 'logDeviceName',
      ellipsis: {
        showTitle: false,
      },
      render: (logDeviceName: string, record: Log) => (
        <LogLink onClick={() => onLogClick(record)}>
          {logDeviceName}
        </LogLink>
      ),
    },
    {
      title: 'Time',
      dataIndex: 'timestamp',
      key: 'timestamp',
      width: 130,
      render: (timestamp: string) =>
        moment(timestamp).format('YYYY-MM-DD HH:mm:ss'),
    },
  ];

  const hasData = logs.length > 0;

  return (
    <>
      <TableWrapper className={hasData ? 'has-data' : 'no-data'}>
        <Table<Log>
          columns={columns}
          dataSource={logs}
          rowKey="id"
          loading={loading}
          pagination={false}
          scroll={hasData ? { x: true, y: 400 } : undefined}
          emptyText="No logs found"
          emptyDescription="No logs found"
          headerBackgroundColor={isDarkMode ? "#1a202c" : "#F2F2F2"}
          removeVerticalBorders={true}
          thPadding="15px 10px"
          tdPadding="10px 10px"
          firstChildBorderRadius="8px"
          border="0"
          borderBottomLeftRight={true}
          theme={isDarkMode ? "dark" : "light"}
        />
      </TableWrapper>
      {logs.length > 0 && (
        <TablePagination
          totalCount={totalItems}
          currentPage={currentPage}
          pageSize={pageSize}
          onChange={onPaginationChange}
          totalLabel="Total logs"
          padding="0px 12px 12px 12px"
        />
      )}
    </>
  );
};

export default LogsTable;
